export default __webpack_public_path__ + "static/media/lio.84b049d2.jpg";